import { render } from "./CaptureReviewWorkflow.vue?vue&type=template&id=897c80a2&scoped=true"
import script from "./CaptureReviewWorkflow.vue?vue&type=script&lang=js"
export * from "./CaptureReviewWorkflow.vue?vue&type=script&lang=js"

import "./CaptureReviewWorkflow.vue?vue&type=style&index=0&id=897c80a2&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897c80a2"]])

export default __exports__